const megaMenuContent = {
  mainNav: [
    {
      text: "Home",
    },
    {
      text: "Company",
    },
    {
      text: "What We Do",
    },
    {
      text: "Portfolio",
    },
    {
      text: "Hire Experts",
    },
    {
      text: "Let's Connect",
    },
    {
      text: "Success Stories",
    },
  ],
  company: {
    heading: "Company insights & Services",
    items: [
      {
        text: "Industries",
        subText:
          "Discover tailored tech solutions that address unique industry challenges & drive innovation.",
        link: "/Industries",
      },
      {
        text: "Life At Bitsclan",
        subText:
          "Explore our vibrant culture, where innovation & teamwork fuel every success.",
        link: "/life-at-bitsclan",
      },
      {
        text: "Success Stories",
        subText:
          "Explore real-world success stories & innovative technology solutions we've delivered.",
        link: "/case-studies",
      },
      {
        text: "Blogs",
        subText:
          "Dive into insights, stories, & updates that shape our journey in tech & innovation.",
        link: "/blogs",
        external: true,
      },
      {
        text: "Engagement Models",
        subText:
          "An engagement model streamlines collaboration by defining scope, roles, & deliverables.",
        link: "/engagment-model",
      },
    ],
  },
  whatWeDo: {
    heading: "Innovative tech solutions",
    items: [
      // {
      //   text: "AI Development",
      //   subText:
      //     "Unlock intelligent solutions that automate, optimize, & elevate business processes.",
      //   link: "/artificial-intelligence-development-services",
      // },
      {
        text: "AI ML Services",
        subText:
          "Harness the power of AI & Machine Learning to automate workflows, drive smarter decisions, & accelerate growth.",
        link: "/ai-ml-development-services",
      },
      {
        text: "AI Chatbot Development",
        subText:
          "Use AI chatbots to automate conversations, boost engagement, & drive growth.",
        link: "/ai-chatbot-development-services",
      },
      {
        text: "AI Automation Services",
        subText:
          "Automate workflows, improve efficiency, & accelerate business growth with AI.",
        link: "/ai-automation-agency",
      },
      {
        text: "AI Agent Development",
        subText:
          "Automate your business processes & get a competitive edge with intelligent AI agents.",
        link: "/ai-agent-development-services",
      },
      {
        text: "Computer Vision Development",
        subText:
          "Automate your business processes & get a competitive edge with intelligent AI agents.",
        link: "/computer-vision-development-services",
      },
      {
        text: "Generative AI Development",
        subText:
          "Leverage generative AI to create smarter solutions, streamline workflows, & drive innovation with customized AI-powered systems.",
        link: "/generative-ai-development-services",
      },
      {
        text: "Web Application Development",
        subText:
          "Crafting robust, scalable web applications to elevate your business online.",
        link: "/web-app-development-services",
      },
      // {
      //   text: "Cyber Security",
      //   subText:
      //     "Protecting your digital assets with comprehensive security solutions against evolving threats.",
      //   link: "/cyber-security-services",
      // },
      {
        text: "Custom Development",
        subText:
          "Tailored software solutions designed to meet your unique business needs.",
        link: "/custom-software-development-services",
      },
      {
        text: "Mobile App Development",
        subText:
          "Creating intuitive mobile experiences that engage users & drive business growth.",
        link: "/mobile-app-development-services",
      },
      // {
      //   text: "Data Analytics",
      //   subText:
      //     "Transforming data into actionable insights to drive informed decision-making & growth.",
      //   link: "/data-analytics-services",
      // },
      {
        text: "DevOps Services",
        subText:
          "Streamlining development & operations for faster delivery & enhanced collaboration.",
        link: "/dev-ops-services",
      },
      {
        text: "Quality Assurance Services",
        subText:
          "Ensuring top-notch quality through rigorous testing & validation for flawless performance.",
        link: "/quality-assurance-services",
      },
    ],
  },
  hireExperts: {
    heading: "Hire Our Experts",
    items: [
      {
        text: "Hire Ruby Rails",
        subText:
          "Expert Ruby on Rails developers ready to build scalable & efficient web applications for your business.",
        link: "/hire-ruby-on-rails-developer",
      },
      {
        text: "Hire Django",
        subText:
          "Skilled Django developers to create powerful, high-performance web applications tailored to your needs.",
        link: "/hire-django-developer",
      },
      {
        text: "Hire Python",
        subText:
          "Talented Python developers available to deliver versatile & efficient solutions for your projects.",
        link: "/hire-python-developers",
      },
      {
        text: "Hire Go Lang",
        subText:
          "Proficient Go developers ready to build high-performance applications with efficiency & speed.",
        link: "/hire-golang-developer",
      },
      {
        text: "Hire JavaScript",
        subText:
          "Experienced JavaScript developers to create dynamic & interactive web applications tailored to your vision.",
        link: "/hire-javascript-developer",
      },
      {
        text: "Hire React",
        subText:
          "Skilled React developers available to craft responsive & high-performing user interfaces for your applications.",
        link: "/hire-react-js-developers",
      },
      {
        text: "Hire Flutter",
        subText:
          "Expert Flutter developers ready to build beautiful, natively compiled applications for mobile, web, & desktop from a single codebase.",
        link: "/hire-flutter-developers",
      },
      {
        text: "Hire android",
        subText:
          "Experienced android developers to create intuitive & robust mobile applications tailored for android users.",
        link: "/hire-android-developers",
      },
      {
        text: "Hire Angular",
        subText:
          "Proficient Angular developers dedicated to building dynamic, high-performance web applications with a seamless user experience.",
        link: "/hire-angular-developer",
      },
      {
        text: "Hire Mern Stack",
        subText:
          "Skilled MERN Stack developers ready to build full-stack applications with MongoDB, Express.js, React, & Node.js for optimal performance.",
        link: "/hire-mern-stack-developer",
      },
      {
        text: "Hire Node",
        subText:
          "Experienced Node.js developers to create scalable & efficient server-side applications that power your business.",
        link: "/hire-node-js-developer",
      },
    ],
  },
};

export default megaMenuContent;
